import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { shouldNotForwardProps } from '@polestar/component-warehouse-react/helpers/shouldForwardProps';
const Row = forwardRef((props, ref) => {
    return React.createElement(Container, { ...props, ref: ref });
});
Row.displayName = 'Row';
export default Row;
const Container = styled('div', shouldNotForwardProps(true, 'crossAxisAlignment', 'reverse', 'mainAxisAlignment', 'stretch'))(({ reverse, mainAxisAlignment, crossAxisAlignment, stretch }) => css(css `
      display: flex;
      flex-direction: ${reverse ? 'row-reverse' : 'row'};
      justify-content: ${mainAxisAlignment};
      align-items: ${crossAxisAlignment};
      max-height: 100%;
    `, stretch &&
    css `
        flex-grow: 1;
      `));
